<div class="flex flex-col gap-y-4 overflow-hidden px-0 lg:px-10">
  <div class="flex justify-between items-end">
    <div class="font-semibold text-xl text-(--color-text-primary)">
      Detalles de punto de conexión {{ data.location.Id }} - {{ data.location.LocationName }}
    </div>

    <button
      (click)="closeModal()"
      class="border! rounded-full border-(--comp-dialog-button-close)!"
      mat-icon-button
    >
      <mat-icon class="text-(--comp-dialog-button-close)!">close</mat-icon>
    </button>
  </div>

  <div class="flex flex-col p-6 gap-y-4 h-[50vh] w-full">
    <div class="flex-1 w-full rounded-2xl overflow-hidden min-h-0">
      <google-map height="100%" width="100%" [center]="center" [zoom]="zoom">
        <map-marker [position]="center"></map-marker>
      </google-map>
    </div>
  </div>
</div>
